<template>
  <modal 
    name="asset-template-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'650px'"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        {{ title }}
      </div>

      <a href="#"
        v-on:click.prevent="$modal.hide('asset-template-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body" v-if="template != null">
      <InputText 
        label="Template name" 
        propertyKey="name"
        objectType="template"
        v-bind:value="template.name"
        v-bind:updateValue="updateValue" />

      <div v-if="nameError !== null" class="text-red-600 mt-1 text-sm">{{ nameError }}</div>

      <div class="label-line">
        <label class="label-standard">Please select which assets should be included in this template</label>
      </div>

      <div class="flex items-center mt-2">
        <input type="checkbox" value="Savings" v-model="template.data" id="input-savings" />
        <label for="input-savings" class="w-56 text-sm text-gray-700 ml-2">Savings</label>
        <MultipleType objectType="Savings" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Owner Occupied Property" v-model="template.data" id="input-owner-occupied-property" />
        <label for="input-owner-occupied-property" class="w-56 text-sm text-gray-700 ml-2">Owner Occupied Property</label>
        <MultipleType objectType="Owner Occupied Property" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Investment Property" v-model="template.data" id="input-investment-property" />
        <label for="input-investment-property" class="w-56 text-sm text-gray-700 ml-2">Investment Property</label>
        <MultipleType objectType="Investment Property" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Vehicle" v-model="template.data" id="input-vehicle" />
        <label for="input-vehicle" class="w-56 text-sm text-gray-700 ml-2">Vehicle</label>
        <MultipleType objectType="Vehicle" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Home Contents" v-model="template.data" id="input-home-contents" />
        <label for="input-home-contents" class="w-56 text-sm text-gray-700 ml-2">Home Contents</label>
        <MultipleType objectType="Home Contents" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Superannuation" v-model="template.data" id="input-superannuation" />
        <label for="input-superannuation" class="w-56 text-sm text-gray-700 ml-2">Superannuation</label>
        <MultipleType objectType="Superannuation" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Investments" v-model="template.data" id="input-investments" />
        <label for="input-investments" class="w-56 text-sm text-gray-700 ml-2">Investments</label>
        <MultipleType objectType="Investments" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>

      <div class="flex items-center mt-1">
        <input type="checkbox" value="Other" v-model="template.data" id="input-other" />
        <label for="input-other" class="w-56 text-sm text-gray-700 ml-2">Other</label>
        <MultipleType objectType="Other" 
          v-bind:isChecked="isChecked"
          v-bind:numType="numType"
          v-bind:increase="increase"
          v-bind:decrease="decrease" />
      </div>
    </div>

    <div class="modal-footer">
      <SubmitButton2 label="Save" v-bind:onClick="submit" v-bind:loading="loading" />
    </div>
  </modal>
</template>

<script>
  import InputRadio     from '@/shared/components/form/InputRadio'
  import InputText      from '@/shared/components/form/InputText'
  import SubmitButton2  from '@/shared/components/form/SubmitButton2'
  import { EventBus }   from '@/shared/event-bus'
  import MultipleType   from './MultipleType'

  export default {

    components : {
      InputRadio,
      InputText,
      SubmitButton2,
      MultipleType
    },

    data() {
      return {
        title    : null,
        loading  : false,
        nameError: null,
        template : null,
        brokerId : null
      }
    },

    methods : {
      beforeOpen(event) {
        if(event.params.brokerId) {
          this.brokerId = event.params.brokerId
        }
        console.log(event.params);
        if(event.params.template != null) {
          this.title    = "Edit asset template"
          this.template = event.params.template
        }

        else {
          this.title    = "Create an asset template"
          this.template = {
            type: 'asset',
            name: null,
            data: ['Savings', 'Owner Occupied Property', 'Investment Property', 'Vehicle', 'Home Contents', 'Superannuation', 'Investments', 'Other'],
          }
        }
      },

      isChecked(type) {
        return _.indexOf(this.template.data, type) > -1
      },

      numType(type) {
        return _.countBy(this.template.data)[type]
      },

      increase(type) {
        this.template.data.push(type)
      },

      decrease(type) {
        let num            = _.countBy(this.template.data)[type]
        this.template.data = _.without(this.template.data, type)
        for(let i=0; i < num-1; i++) {
          this.template.data.push(type)
        }
      },

      updateValue(params) {
        this.template[params.key] = params.value
      },

      submit() {
        let valid      = true
        this.nameError = null
        
        if(this.template.name == null || this.template.name.length == 0) {
          this.nameError = "Please provide a valid name for this template"
          valid = false
        }

        if(valid) {

          // let's re-organize the template.data
          let arr = []
          for(let i=0; i < this.template.data.length; i++) {
            let index = _.indexOf(arr, this.template.data[i])

            if(index == -1) {
              arr.push(this.template.data[i])
            }

            else {
              arr.splice(index, 0, this.template.data[i])
            }
          }

          this.template.data = arr

          this.loading = true
          this.apiPost({
            template : this.template,
            brokerId : this.brokerId
          }, 'template/save', () => {
            this.loading = false
            this.$modal.hide('asset-template-modal')
            EventBus.$emit('get-templates')
            EventBus.$emit('notification-event', {
              'type'   : 'success',
              'message': "Template saved successfully"
            })
          })
        }
      },
    }
  }
</script>